import { render, staticRenderFns } from "./SearchCategory.vue?vue&type=template&id=3efb4774&"
import script from "./SearchCategory.vue?vue&type=script&lang=ts&"
export * from "./SearchCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports